import { Icon, Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import React, { useState } from "react";

import ArgonBox from "components/ArgonBox";
import ArgonButton from "components/ArgonButton";
import ArgonInput from "components/ArgonInput";
import ArgonTypography from "components/ArgonTypography";
import { useArgonController } from "context";

const ColumnHeader = ({ column, deleteMode, onDeleteColumn, onAddCard }) => {
  const [controller] = useArgonController();
  const { darkMode } = controller;
  const [showForm, setShowForm] = useState(false);
  const [value, setValue] = useState("");

  const canDelete = deleteMode && !column.isLocked && column.title !== "Lead da chiamare";

  const handleAddCard = () => {
    if (!value.trim()) return;
    onAddCard(column.id, value);
    setValue("");
    setShowForm(false);
  };

  return (
    <ArgonBox>
      <ArgonBox display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <ArgonBox
          display="flex"
          alignItems="center"
          onClick={canDelete ? () => onDeleteColumn(column.id) : undefined}
          sx={{
            cursor: canDelete ? "pointer" : "default",
            ...(canDelete && {
              "&:hover": { color: "error.main" },
            }),
          }}
        >
          {column.title === "Lead da chiamare" || column.isLocked ? (
            <Tooltip title="This column cannot be deleted or moved">
              <Icon sx={{ fontSize: 20, mr: 1, color: "info.main" }}>lock</Icon>
            </Tooltip>
          ) : !deleteMode ? (
            <Icon sx={{ fontSize: 20, mr: 1 }}>drag_indicator</Icon>
          ) : (
            <Tooltip title="Click to delete this column">
              <Icon sx={{ fontSize: 20, mr: 1, color: "error.light" }}>delete_sweep</Icon>
            </Tooltip>
          )}
        </ArgonBox>

        <ArgonTypography variant="h6" fontWeight="bold" textTransform="capitalize">
          {column.title}
        </ArgonTypography>

        <ArgonButton
          size="medium"
          variant={darkMode ? "outlined" : "contained"}
          onClick={() => setShowForm(true)}
          disabled={deleteMode}
          sx={{
            minWidth: 36,
            height: 36,
            borderRadius: "999px",
            backgroundImage:
              !darkMode && 'url("https://qlickup.it/wp-content/uploads/2025/04/SFONDO-1.jpg")',
            backgroundSize: "cover!important",
            padding: "6px",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            minHeight: "unset",
            "&:hover": {
              rotate: "90deg",
              backgroundImage:
                !darkMode && 'url("https://qlickup.it/wp-content/uploads/2025/04/SFONDO-1.jpg")',
            },
          }}
        >
          <Icon sx={{ fontWeight: "bold", color: "#fff" }}>add</Icon>
        </ArgonButton>
      </ArgonBox>

      {showForm && (
        <ArgonBox my={2.5}>
          <ArgonInput
            value={value}
            inputProps={{ rows: 2 }}
            onChange={(e) => setValue(e.target.value)}
            multiline
            placeholder="Nuova card"
          />
          <ArgonBox display="flex" mt={2}>
            <ArgonButton variant="gradient" color="primary" size="small" onClick={handleAddCard}>
              Aggiungi
            </ArgonButton>
            <ArgonBox ml={1}>
              <ArgonButton
                variant="gradient"
                color="light"
                size="small"
                onClick={() => {
                  setValue("");
                  setShowForm(false);
                }}
              >
                Annulla
              </ArgonButton>
            </ArgonBox>
          </ArgonBox>
        </ArgonBox>
      )}
    </ArgonBox>
  );
};

ColumnHeader.propTypes = {
  column: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    title: PropTypes.string.isRequired,
    isLocked: PropTypes.bool,
  }).isRequired,
  deleteMode: PropTypes.bool,
  onDeleteColumn: PropTypes.func,
  onAddCard: PropTypes.func.isRequired,
};

ColumnHeader.defaultProps = {
  deleteMode: false,
  onDeleteColumn: () => {},
};

export default ColumnHeader;
